export default "__VITE_ASSET__wBp8b3W2__"